import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Message } from '../_models/message';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private subject = new Subject<any>();
  private legendSubject = new Subject<any>();
  messageReceived = new EventEmitter<Message>();
  selectedLanguage = new BehaviorSubject<any>('');

  /************* User Data ********************************** */
  sendMessage(Message: any) {
    this.subject.next(Message);
  }

  clearMessages() {
    this.subject.next();
  }
  
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
  onMessage(): Observable<any> {
    return this.subject.asObservable();
  }
  /************* Legends********************************** */
  sendLegendData(data: any) {
    this.legendSubject.next(data);
  }
  getLegendData(): Observable<any> {
    return this.legendSubject.asObservable();
  }
  onLegendData(): Observable<any> {
    return this.legendSubject.asObservable();
  }

}
